import {SkeletonText, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow} from '@carbon/react';
import {IReportsTableHeaders} from '../../types';
import React, {useMemo} from 'react';


interface IReportsTableProps<T> {
    rows: Array<T>;
    headers: IReportsTableHeaders;
    getTableCellLabels: (row: T) => React.ReactNode[];
    className?: string;
    error?: string | null;
    loading: boolean;
    loadingRows: number;
    loadingColumns: number;
}

const ReportsTable = <T,>(props: IReportsTableProps<T>) => {
    const {
        rows, 
        headers, 
        getTableCellLabels, 
        error, 
        loading,
        loadingRows,
        loadingColumns
    } = props;
    let {className} = props;
    className = useMemo(() => {
        let baseClass = 'reports-table';
        return className ? `${baseClass} ${className}` : baseClass;
    }, [className]);

    return (
        <TableContainer>
            <Table className={className}>
                <TableHead>
                    {headers.map((headerRow, i) => {
                        const {items, ...rest} = headerRow;
                        return (
                            <TableRow key={i} {...rest}>
                                {items.map((headerCell, index) => {
                                    const {label, colSpan = 1} = headerCell as { label?: string, colSpan?: number };
                                    if (!label) {
                                        return <TableHeader key={index} colSpan={colSpan} />;
                                    }
                                    return (
                                        <TableHeader key={index} colSpan={colSpan}>
                                            <div className='cds--table-header-label'>
                                                {label}
                                            </div>
                                        </TableHeader>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableHead>
                <TableBody>
                    {!!error && (
                        <TableRow>
                            <TableCell colSpan={loadingColumns}>
                                <div className="error-message">{error}</div>
                            </TableCell>
                        </TableRow>
                    )}
                    {loading && [...Array(loadingRows)].map((_, index) => {
                        return (
                            <TableRow key={index}>
                                {[...Array(loadingColumns)].map((_, i) => {
                                    return <TableCell key={i}><SkeletonText /></TableCell>;
                                })}
                            </TableRow>
                        );
                    })}
                    {!error && !loading && rows.map((row, index) => {
                        return (
                            <TableRow key={index}>
                                {getTableCellLabels(row).map((label, i) => {
                                    return <TableCell key={i}>{label}</TableCell>;
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ReportsTable;
